import app from "../firebase/firebaseConfig";
import { getFunctions, httpsCallable } from "firebase/functions";
import initializeStripe from "./initializeStripe";

type SubscriptionCheckoutResponse = {
  sessionId?: string;
  url?: string | null;
};

/**
 * Start Stripe Checkout for a Pro subscription.
 * Uses Cloud Function `createSubscriptionCheckoutSession` (mode: subscription).
 */
export async function createCheckoutSession(uid: string, priceId: string = "price_1Tvmh6H9z0ThRFdKBMzLb7U2") {
  if (typeof window === "undefined" || !uid) {
    throw new Error("Checkout must run in the browser with a signed-in user.");
  }

  const functions = getFunctions(app, "us-central1");
  const createSubscriptionCheckoutSession = httpsCallable(functions, "createSubscriptionCheckoutSession");

  const result = await createSubscriptionCheckoutSession({
    priceId,
    origin: window.location.origin,
  });

  const data = result.data as SubscriptionCheckoutResponse;

  if (data?.url) {
    window.location.assign(data.url);
    return;
  }

  if (data?.sessionId) {
    const stripe = await initializeStripe();
    if (!stripe) {
      throw new Error("Stripe.js failed to load.");
    }
    const { error } = await stripe.redirectToCheckout({ sessionId: data.sessionId });
    if (error) {
      throw error;
    }
    return;
  }

  throw new Error("No checkout session returned from server.");
}
